window.slate = window.slate || {};
window.theme = window.theme || {};

/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {
  
  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function() {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled){
      document.cookie = 'testcookie';
      cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
    }
    return cookieEnabled;
  }
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function(array, key, value) {
    var i = array.length;
    while(i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  }
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap iframes and tables in div tags to force responsive/scrollable layout.
 *
 * @namespace rte
 */

slate.rte = {
  /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
  wrapTable: function(options) {
    var tableWrapperClass = typeof options.tableWrapperClass === "undefined" ? '' : options.tableWrapperClass;

    options.$tables.wrap('<div class="' + tableWrapperClass + '"></div>');
  },

  /**
   * Wrap iframes in a container div to make them responsive
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
  wrapIframe: function(options) {
    var iframeWrapperClass = typeof options.iframeWrapperClass === "undefined" ? '' : options.iframeWrapperClass;

    options.$iframes.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="' + iframeWrapperClass + '"></div>');
      
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:section:reorder', this._onReorder.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
  },

  _onSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function () {
  var moneyFormat = '${{amount}}';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function() {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));

    var __variants = this;
    $(document).ready(function(){
      __variants._filterCarouselImages(__variants.currentVariant)
    })
  }

  Variants.prototype = $.extend({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function(variant) {
        var satisfied = true;

        selectedValues.forEach(function(option) {
          if (satisfied) {
            satisfied = (option.value === variant[option.index]);
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },

    // _getVariantFromOptions: function() {
    //   var selectedValues = this._getCurrentOptions();
    //   var variants = this.product.variants;

    //   var found = jQuery.find(variants, function(variant) {
    //     return selectedValues.every(function(values) {
    //       return jQuery.isEqual(variant[values.index], values.value);
    //     });
    //   });

    //   return found;
    // },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      // console.log('_onSelectChange');
      var variant = this._getVariantFromOptions();
      // console.log(variant);

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }

      this._filterCarouselImages(variant)
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      // console.log('_updateImages');
      // console.log(variant);

      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      // console.log(variantImage);
      // console.log(currentVariantImage);

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },
    _filterCarouselImages(variant) {
      const current_variant = variant.title
      const product_gallery_class = '.product-media-gallery-list'
      const thumb_gallery_class = '.product-media-gallery-thumbnail-list'
      const $sliders = $(`${product_gallery_class}, ${thumb_gallery_class}`, this.$container)

      $sliders.slick('slickUnfilter')
      $sliders.slick('slickFilter', function() {
          const slide = $(this)
          const img = slide.find('img')
          const img_alt = img.attr("alt")
          if (
              //display if no variants in alt tag or...
              img_alt.indexOf('||') === -1
              //display if variants in alt tag and matches selected variant
              || (img_alt.indexOf('||') !== -1 && img_alt.indexOf(current_variant) !== -1) 
          ){
              return true
          }
      });
      
      /**
       * Known issue: https://github.com/kenwheeler/slick/issues/1043
       */
      $sliders.each(function(index,slide){
        var s_id = 0;
        $(".slick-slide:not(.slick-cloned)",slide).each(function(s_index,s_slide) {
            $(this).attr("data-slick-index",s_id)
            s_id = s_id+1;
            if (index==0) {
                if ($(this).hasClass("slick-current")) {
                    active_index = s_id;
                }
            }
            if (index==1) {
                if (s_id==active_index) {
                    $(this).addClass("slick-current");
                } else {
                    $(this).removeClass("slick-current");
                }
            }
        })
      })
      $sliders.slick('slickGoTo',0,true);

    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param {object} variant - Currently selected variant
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({path: newurl}, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param {object} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    }
  });

  return Variants;
})();


/*================ Utilities ================*/
function createCookie(name, value, days) {
  let expires;
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    expires = `; expires=${date.toGMTString()}`;
  } else {
    expires = '';
  }
  document.cookie = `${name}=${value}${expires}; path=/`;
}

function readCookie(name) {
  const nameEQ = `${name}=`;
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let char = ca[i];
    while (char.charAt(0) === ' ') {
      char = char.substring(1, char.length);
    }
    if (char.indexOf(nameEQ) === 0) {
      return char.substring(nameEQ.length, char.length);
    }
  }
  return null;
}

function eraseCookie(name) {
  createCookie(name, '', -1);
}


/*================ Sections ================*/

$(document).ready(function () {

  var heroBanner = $('.shopify-section.hero-banner');
  heroBanner.addClass('remove');

  var scheduleBanner_1 = false;

  $.each(heroBanner, function(ii,ee){
    var el = $(ee),
        sectionHeroBanner = el.find('.section--hero-banner');

    var scheduledDate = sectionHeroBanner.data('scheduleddate');
    var scheduledDateEnd = sectionHeroBanner.data('scheduleddateend');
    var scheduledTime = sectionHeroBanner.data('scheduledtime');
    var scheduledTimeEnd = sectionHeroBanner.data('scheduledtimeend');

    var startDateParts = scheduledDate.split('-').map( p => parseInt(p)),
        endDateParts = scheduledDateEnd.split('-').map( p => parseInt(p)),
        startTimeParts = scheduledTime.split(':').map( p => parseInt(p)),
        endTimeParts = scheduledTimeEnd.split(':').map( p => parseInt(p)),
        currentDateTime = new Date(),
        startDateTime = new Date(startDateParts[0], (startDateParts[1] - 1), startDateParts[2], startTimeParts[0], startTimeParts[1]),
        endDateTime = new Date(endDateParts[0], (endDateParts[1] - 1), endDateParts[2], endTimeParts[0], endTimeParts[1]);

      //console.log(startDateParts, startTimeParts, endDateParts, endTimeParts, currentDateTime, startDateTime, endDateTime);

      if (currentDateTime >= startDateTime && currentDateTime <= endDateTime) {
        el.removeClass('remove').addClass('show').show();
        scheduleBanner_1 = true;
      }

  });

  if(scheduleBanner_1==false){
    $('.shopify-section.hero-banner:first-child').removeClass('remove').addClass('show').show();
  }

  $('.shopify-section.hero-banner.remove').remove();

});

/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
   * @namespace product
 */

theme.Product = (function() {



  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Product(container) {
    this.$container = $(container);

    var sectionId = this.$container.attr('data-section-id');



    // var selectors = {
    //   addToCart: '[data-add-to-cart]',
    //   addToCartText: '[data-add-to-cart-text]',
    //   comparePrice: '[data-compare-price]',
    //   comparePriceText: '[data-compare-text]',
    //   originalSelectorId: '[data-product-select]',
    //   priceWrapper: '[data-price-wrapper]',
    //   productFeaturedImage: '[data-product-featured-image]',
    //   productJson: '[data-product-json]',
    //   productPrice: '[data-product-price]',
    //   productThumbs: '[data-product-single-thumbnail]',
    //   singleOptionSelector: '[data-single-option-selector]'
    // };




    // =====
    this.selectors = {
      productJson: '[data-product-json]',
      priceWrapper: '[data-price-wrapper]',

      productPrice: '[data-product-price]',

      addToCart: '[data-add-to-cart]',
      addToCartText: '[data-add-to-cart-text]',

      productQuantity: '[data-product-qty]',

      // errorQuantityMessage: '#error-quantity-' + sectionId,
      quantity: '#Quantity',
      SKU: '.variant-sku',
      productStatus: '[data-product-status]',
      originalSelectorId: '[data-product-select]',

      productImageWraps: '.product-single__photo',
      productThumbImages: '.product-single__thumbnail--' + sectionId,
      productThumbs: '[data-product-single-thumbnail]',
      productFeaturedImage: '[data-product-featured-image]',
      productThumbsWrapper: '.thumbnails-wrapper',

      saleLabel: '.product-price__sale-label-' + sectionId,

      // singleOptionSelector: '[data-single-option-selector]',
      singleOptionSelector: '.single-option-selector-' + sectionId,


      shopifyPaymentButton: '.shopify-payment-button',
      priceContainer: '[data-price]',
      regularPrice: '[data-regular-price]',
      salePrice: '[data-sale-price]'

      ,productGalleryFeaturedSlider: '.product-media-gallery-list'
    };


    this.classes = {
      hidden: 'hide',
      productOnSale: 'price--on-sale',
      productUnavailable: 'price--unavailable'
    };

    // =====

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$(this.selectors.productJson, this.$container).html()) {
      return;
    }

    this.productSingleObject = JSON.parse($(this.selectors.productJson, this.$container).html());

    var options = {
      $container: this.$container,
      enableHistoryState: this.$container.data('enable-history-state') || false,
      singleOptionSelector: this.selectors.singleOptionSelector,
      originalSelectorId: this.selectors.originalSelectorId,
      product: this.productSingleObject
    };

    // this.settings = {};

    this.settings = {
      // Breakpoints from src/stylesheets/global/variables.scss.liquid
      mediaQueryMediumUp: 'screen and (min-width: 750px)',
      mediaQuerySmall: 'screen and (max-width: 749px)',
      bpSmall: false,
      // enableHistoryState: $container.data('enable-history-state') || false,
      enableHistoryState: this.$container.data('enable-history-state') || false,
      namespace: '.slideshow-' + sectionId,
      sectionId: sectionId,
      sliderActive: false,
      // sliderActive: true,
      // zoomEnabled: false
      zoomEnabled: true
    };

    // this.namespace = '.product';
    // this.variants = new slate.Variants(options);
    // this.$featuredImage = $(this.selectors.productFeaturedImage, this.$container);

    // this.$container.on('variantChange' + this.namespace, this.updateAddToCartState.bind(this));
    // this.$container.on('variantPriceChange' + this.namespace, this.updateProductPrices.bind(this));

    // if (this.$featuredImage.length > 0) {
    //   this.settings.imageSize = slate.Image.imageSize(this.$featuredImage.attr('src'));
    //   slate.Image.preload(this.productSingleObject.images, this.settings.imageSize);

    //   this.$container.on('variantImageChange' + this.namespace, this.updateProductImage.bind(this));
    // }



    // this.settings.zoomEnabled = $(this.selectors.productImageWraps).hasClass(
    //   'js-zoom-enabled'
    // );

    // this.settings.zoomEnabled = true;

    this._initBreakpoints();
    this._stringOverrides();
    this._initVariants();
    // this._initImageSwitch();
    this._initAddToCart();
    // this._setActiveThumbnail();

    // this._initVariantImage();
  }

  Product.prototype = $.extend({}, Product.prototype, {


    _stringOverrides: function() {
      theme.productStrings = theme.productStrings || {};
      $.extend(theme.strings, theme.productStrings);
    },

    _initBreakpoints: function() {
      var self = this;

      // _enableZoom(this);

      $(self.selectors.productImageWraps).each(function() {
        _enableZoom(this);
      });


      // enquire.register(this.settings.mediaQuerySmall, {
      //   match: function() {
      //     // initialize thumbnail slider on mobile if more than three thumbnails
      //     if ($(self.selectors.productThumbImages).length > 3) {
      //       self._initThumbnailSlider();
      //     }

      //     // destroy image zooming if enabled
      //     /*
      //     if (self.settings.zoomEnabled) {
      //       $(self.selectors.productImageWraps).each(function() {
      //         _destroyZoom(this);
      //       });
      //     }
      //     */

      //     self.settings.bpSmall = true;
      //   },
      //   unmatch: function() {
      //     if (self.settings.sliderActive) {
      //       self._destroyThumbnailSlider();
      //     }

      //     self.settings.bpSmall = false;
      //   }
      // });

      // enquire.register(this.settings.mediaQueryMediumUp, {
      //   match: function() {
      //     if (self.settings.zoomEnabled) {
      //       $(self.selectors.productImageWraps).each(function() {
      //         _enableZoom(this);
      //       });
      //     }
      //   }
      // });
    },


    _initVariants: function() {
      var options = {
        $container: this.$container,
        enableHistoryState: this.$container.data('enable-history-state') || false,
        singleOptionSelector: this.selectors.singleOptionSelector,
        originalSelectorId: this.selectors.originalSelectorId,
        product: this.productSingleObject
      };

      this.variants = new slate.Variants(options);

      this.$container.on(
        'variantChange' + this.settings.namespace,
        this._updateAvailability.bind(this)
      );
      this.$container.on(
        'variantImageChange' + this.settings.namespace,
        this._updateImages.bind(this)
      );
      this.$container.on(
        'variantPriceChange' + this.settings.namespace,
        this._updatePrice.bind(this)
      );
      this.$container.on(
        'variantSKUChange' + this.settings.namespace,
        this._updateSKU.bind(this)
      );
    },

    /*_initImageSwitch: function() {
      if (!$(this.selectors.productThumbImages).length) {
        return;
      }

      var self = this;

      $(this.selectors.productThumbImages)
        .on('click', function(evt) {
          evt.preventDefault();
          var $el = $(this);

          var imageId = $el.data('thumbnail-id');

          self._switchImage(imageId);
          self._setActiveThumbnail(imageId);
        })
        .on('keyup', self._handleImageFocus.bind(self));
    },*/

    _initAddToCart: function() {
      var self = this;
      var $quantityInput = $(self.selectors.quantity);

      if ($quantityInput.length === 0) return;

      $(self.selectors.addToCart).on('click', function(evt) {
        var isInvalidQuantity = $quantityInput.val() <= 0;

        $(self.selectors.errorQuantityMessage).toggleClass(
          self.classes.hidden,
          !isInvalidQuantity
        );

        if (isInvalidQuantity) {
          $quantityInput
            .attr(
              'aria-describedby',
              'error-quantity-' + self.settings.sectionId
            )
            .attr('aria-invalid', true);
          $(self.selectors.errorQuantityMessage).focus();
          evt.preventDefault();
        } else {
          $quantityInput
            .removeAttr('aria-describedby')
            .removeAttr('aria-invalid');
        }
      });
    },

    /*_setActiveThumbnail: function(imageId) {
      var activeClass = 'active-thumb';

      // If there is no element passed, find it by the current product image
      if (typeof imageId === 'undefined') {
        imageId = $(this.selectors.productImageWraps + ":not('.hide')").data(
          'image-id'
        );
      }

      var $thumbnail = $(
        this.selectors.productThumbImages +
          "[data-thumbnail-id='" +
          imageId +
          "']"
      );

      $(this.selectors.productThumbImages)
        .removeClass(activeClass)
        .removeAttr('aria-current');

      $thumbnail.addClass(activeClass);
      $thumbnail.attr('aria-current', true);
    },*/

    /*_switchImage: function(imageId) {
      var $newImage = $(
        this.selectors.productImageWraps + "[data-image-id='" + imageId + "']",
        this.$container
      );
      var $otherImages = $(
        this.selectors.productImageWraps +
          ":not([data-image-id='" +
          imageId +
          "'])",
        this.$container
      );

      $newImage.removeClass(this.classes.hidden);
      $otherImages.addClass(this.classes.hidden);
    },*/




    _initVariantImage: function(variantId) {


      // var options = {
      //   $container: this.$container,
      //   enableHistoryState: this.$container.data('enable-history-state') || false,
      //   singleOptionSelector: this.selectors.singleOptionSelector,
      //   originalSelectorId: this.selectors.originalSelectorId,
      //   product: this.productSingleObject
      // };

      // this.variants = new slate.Variants(options);

      // var variant = evt.variant;
      // var imageId = variant.featured_image.id;


      var params = new URLSearchParams(window.location.search);
      var variantId = params.get('variant');

      console.log('variantId');
      console.log(variantId);

      if (variantId == undefined) {
        return;
      }


      console.log('_initVariantImage');
      console.log(this.productSingleObject);

      console.log(this.productSingleObject.variants);

      var found = false;
      $(this.productSingleObject.variants).each(function(i, variant) {

        if (variant.id == variantId) {
          found = variant;
          console.log( variant );
        }
      });




      if (found) {
        var imageId = found.featured_image.id;
        this._switchGalleryImage(imageId);
      }

    },




    _switchGalleryImage: function(imageId) {
      var $newImage = $(
        this.selectors.productImageWraps + "[data-image-id='" + imageId + "']",
        this.$container
      );


      var $gallerySlider = $(this.selectors.productGalleryFeaturedSlider);
      // this.selectors.productGalleryFeaturedSlider



      console.log('_switchGalleryImage');
      console.log($newImage);



      var slickImageIndex = $newImage.parent().data('slick-index');
      console.log('slick-index');
      console.log(slickImageIndex);

      console.log('$gallerySlider');
      console.log($gallerySlider);

      $gallerySlider.slick('slickGoTo', slickImageIndex);

    },



    _handleImageFocus: function(evt) {
      if (evt.keyCode !== slate.utils.keyboardKeys.ENTER) return;

      $(this.selectors.productFeaturedImage + ':visible').focus();
    },

    /*_initThumbnailSlider: function() {
      var options = {
        slidesToShow: 4,
        slidesToScroll: 3,
        infinite: false,
        prevArrow: '.thumbnails-slider__prev--' + this.settings.sectionId,
        nextArrow: '.thumbnails-slider__next--' + this.settings.sectionId,
        responsive: [
          {
            breakpoint: 321,
            settings: {
              slidesToShow: 3
            }
          }
        ]
      };

      $(this.selectors.productThumbs).slick(options);

      // Accessibility concerns not yet fixed in Slick Slider
      $(this.selectors.productThumbsWrapper, this.$container)
        .find('.slick-list')
        .removeAttr('aria-live');
      $(this.selectors.productThumbsWrapper, this.$container)
        .find('.slick-disabled')
        .removeAttr('aria-disabled');

      this.settings.sliderActive = true;
    },*/

    /*_destroyThumbnailSlider: function() {
      $(this.selectors.productThumbs).slick('unslick');
      this.settings.sliderActive = false;

      // Accessibility concerns not yet fixed in Slick Slider
      $(this.selectors.productThumbsWrapper, this.$container)
        .find('[tabindex="-1"]')
        .removeAttr('tabindex');
    },*/

    _liveRegionText: function(variant) {
      // Dummy content for live region
      var liveRegionText = '[Availability] [Regular] [$$] [Sale] [$]';

      if (!variant) {
        liveRegionText = theme.strings.unavailable;
        return liveRegionText;
      }

      // Update availability
      var availability = variant.available ? '' : theme.strings.soldOut + ',';
      liveRegionText = liveRegionText.replace('[Availability]', availability);

      // Update pricing information
      var regularLabel = '';
      var regularPrice = theme.Currency.formatMoney(
        variant.price,
        theme.moneyFormat
      );
      var saleLabel = '';
      var salePrice = '';

      if (variant.compare_at_price > variant.price) {
        regularLabel = theme.strings.regularPrice;
        regularPrice =
          theme.Currency.formatMoney(
            variant.compare_at_price,
            theme.moneyFormat
          ) + ',';
        saleLabel = theme.strings.sale;
        salePrice = theme.Currency.formatMoney(
          variant.price,
          theme.moneyFormat
        );
      }

      liveRegionText = liveRegionText
        .replace('[Regular]', regularLabel)
        .replace('[$$]', regularPrice)
        .replace('[Sale]', saleLabel)
        .replace('[$]', salePrice)
        .trim();

      return liveRegionText;
    },

    _updateLiveRegion: function(evt) {
      var variant = evt.variant;
      var liveRegion = this.container.querySelector(
        this.selectors.productStatus
      );

      liveRegion.textContent = this._liveRegionText(variant);
      liveRegion.setAttribute('aria-hidden', false);

      // hide content from accessibility tree after announcement
      setTimeout(function() {
        liveRegion.setAttribute('aria-hidden', true);
      }, 1000);
    },

    _updateAddToCart: function(evt) {
      var variant = evt.variant;

      if (variant) {
        if (variant.available) {
          $(this.selectors.addToCart).prop('disabled', false);
          $(this.selectors.productQuantity).prop('disabled', false);
          $(this.selectors.addToCartText).text(theme.strings.addToCart);
          $(this.selectors.shopifyPaymentButton, this.$container).show();
        } else {
          // The variant doesn't exist, disable submit button and change the text.
          // This may be an error or notice that a specific variant is not available.
          $(this.selectors.addToCart).prop('disabled', true);
          $(this.selectors.productQuantity).prop('disabled', true);
          $(this.selectors.addToCartText).text(theme.strings.soldOut);
          $(this.selectors.shopifyPaymentButton, this.$container).hide();
        }
      } else {
        $(this.selectors.addToCart).prop('disabled', true);
        $(this.selectors.productQuantity).prop('disabled', true);
        $(this.selectors.addToCartText).text(theme.strings.unavailable);
        $(this.selectors.shopifyPaymentButton, this.$container).hide();
      }
    },

    _updateAvailability: function(evt) {
      // update form submit
      this._updateAddToCart(evt);
      // update live region
      this._updateLiveRegion(evt);

      this._updatePrice(evt);
    },

    _updateImages: function(evt) {
      var variant = evt.variant;
      var imageId = variant.featured_image.id;

      console.log('_updateImages');
      console.log(evt);
      console.log(variant);
      console.log(imageId);

      // this._switchImage(imageId);
      // this._setActiveThumbnail(imageId);

      this._switchGalleryImage(imageId);
    },

    _updatePrice: function(evt) {
      var variant = evt.variant;

      var $priceContainer = $(this.selectors.priceContainer, this.$container);
      var $regularPrice = $(this.selectors.regularPrice, $priceContainer);
      var $salePrice = $(this.selectors.salePrice, $priceContainer);

      // Reset product price state
      $priceContainer
        .removeClass(this.classes.productUnavailable)
        .removeClass(this.classes.productOnSale)
        .removeAttr('aria-hidden');

      // Unavailable
      if (!variant) {
        $priceContainer
          .addClass(this.classes.productUnavailable)
          .attr('aria-hidden', true);
        return;
      }

      // On sale
      if (variant.compare_at_price > variant.price) {
        $regularPrice.html(
          theme.Currency.formatMoney(
            variant.compare_at_price,
            theme.moneyFormat
          )
        );
        $salePrice.html(
          theme.Currency.formatMoney(variant.price, theme.moneyFormat)
        );
        $priceContainer.addClass(this.classes.productOnSale);
      } else {
        // Regular price
        $regularPrice.html(
          theme.Currency.formatMoney(variant.price, theme.moneyFormat)
        );
      }
    },

    _updateSKU: function(evt) {
      var variant = evt.variant;

      // Update the sku
      $(this.selectors.SKU).html(variant.sku);
    },

    onUnload: function() {
      this.$container.off(this.settings.namespace);
    },


    // =========================================================================







    /**
     * Updates the DOM state of the add to cart button
     *
     * @param {boolean} enabled - Decides whether cart is enabled or disabled
     * @param {string} text - Updates the text notification content of the cart
     */
    /*updateAddToCartState: function(evt) {
      var variant = evt.variant;

      if (variant) {
        $(this.selectors.priceWrapper, this.$container).removeClass('hide');
      } else {
        $(this.selectors.addToCart, this.$container).prop('disabled', true);
        $(this.selectors.addToCartText, this.$container).html(theme.strings.unavailable);
        $(this.selectors.priceWrapper, this.$container).addClass('hide');
        return;
      }

      if (variant.available) {
        $(this.selectors.addToCart, this.$container).prop('disabled', false);
        $(this.selectors.addToCartText, this.$container).html(theme.strings.addToCart);
      } else {
        $(this.selectors.addToCart, this.$container).prop('disabled', true);
        $(this.selectors.addToCartText, this.$container).html(theme.strings.soldOut);
      }
    },*/

    /**
     * Updates the DOM with specified prices
     *
     * @param {string} productPrice - The current price of the product
     * @param {string} comparePrice - The original price of the product
     */
    /*updateProductPrices: function(evt) {
      var variant = evt.variant;
      var $comparePrice = $(this.selectors.comparePrice, this.$container);
      var $compareEls = $comparePrice.add(this.selectors.comparePriceText, this.$container);

      $(this.selectors.productPrice, this.$container)
        .html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));

      if (variant.compare_at_price > variant.price) {
        $comparePrice.html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));
        $compareEls.removeClass('hide');
      } else {
        $comparePrice.html('');
        $compareEls.addClass('hide');
      }
    },*/

    /**
     * Updates the DOM with the specified image URL
     *
     * @param {string} src - Image src URL
     */
    /*updateProductImage: function(evt) {
      var variant = evt.variant;
      var sizedImgUrl = slate.Image.getSizedImageUrl(variant.featured_image.src, this.settings.imageSize);

      this.$featuredImage.attr('src', sizedImgUrl);
    },*/

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    /*onUnload: function() {
      this.$container.off(this.namespace);
    }*/
  });








  function _enableZoom(el) {
    var zoomUrl = $(el).data('zoom');
    $(el).zoom({
      url: zoomUrl,

      on: 'click',

      touch: true,

      // callback: function(){
      //   console.log('ZOOM THIS');
      //   // console.log($(this));
      //   // console.log($(el));
      //   $(el).addClass('class_name')
      // },


      onZoomIn: function(){
        $(el).addClass('js-zoom-active');
      },

      onZoomOut: function(){
        $(el).removeClass('js-zoom-active');
      }

    });
  }

  function _destroyZoom(el) {
    $(el).trigger('zoom.destroy');
  }

  return Product;
})();


/*================ Templates ================*/
/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function() {
  var $newAddressForm = $('#AddressNewForm');

  if (!$newAddressForm.length) {
    return;
  }

  // Initialize observers on address selectors, defined in shopify_common.js
  if (Shopify) {
    new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
      hideElement: 'AddressProvinceContainerNew'
    });
  }

  // Initialize each edit form's country/province selector
  $('.address-country-option').each(function() {
    var formId = $(this).data('form-id');
    var countrySelector = 'AddressCountry_' + formId;
    var provinceSelector = 'AddressProvince_' + formId;
    var containerSelector = 'AddressProvinceContainer_' + formId;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector
    });
  });

  // Toggle new/edit address forms
  $('.address-new-toggle').on('click', () => {
    $newAddressForm.toggleClass('hide');
    $('.saved-addresses__container').toggleClass('hide');
    $('.pagination').toggleClass('hide');
  });

  $('.address-edit-toggle').on('click', function() {
    const formId = $(this).data('form-id');
    $(`#EditAddress_${formId}`).toggleClass('hide');
    $(`#EditAddress_${formId}`).closest('.edit-address__container').toggleClass('hide');
    $('.saved-addresses__container').toggleClass('hide');
    $('.pagination').toggleClass('hide');
  });

  $('.address-delete').on('click', function() {
    var $el = $(this);
    var formId = $el.data('form-id');
    var confirmMessage = $el.data('confirm-message');
    if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
      Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
    }
  });

  if($('.saved-addresses__inner .saved-address').length){
    $('.saved-addresses__inner .no-address').toggleClass('hide');
    $('.saved-addresses__inner .button').toggleClass('hide');
    $('.saved-addresses__container').toggleClass('no-addresses');
  }

})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function() {
  var config = {
    recoverPasswordForm: '#RecoverPassword',
    hideRecoverPasswordLink: '#HideRecoverPasswordLink'
  };

  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }
})();


$(document).ready(function () {
    rivets.formatters.replace = function (a, b, c) {
        return a.indexOf(b) > -1 ? a.replace(b, c) : a
    }
    CartJS.init(window.__CART_JSON__
        , { debug: true }
    );

    var $cart = {
        gwpCount: 0,
        variantMetafieldArr: [],
        open: '.cartTrigger',
        close: '.side-cart-overlay, #close-side-cart, #contShoppingLink',
        list: '.cart-upsell-list',
        ajaxCartOpen: function () {
            $('body').addClass('ajax-cart-open');
        },
        ajaxCartClose: function () {
            $('body').removeClass('ajax-cart-open');
        },
        updateFreeShipping() {
            if (CartJS.cart.total_price > 4899) {
                $('.free-shipping').addClass('success');
            } else {
                $('.free-shipping').removeClass('success');
            }
        },
    }

    $(document).on('click', $cart.open, function (e) {
        e.preventDefault();
        $cart.ajaxCartOpen();
    });

    $(document).on('click', $cart.close, function (e) {
        e.preventDefault();
        $cart.ajaxCartClose()
    });

    // Cart redirect
    (function cardRedirect() {
        if (window.location.href.indexOf("#sidecart") > -1) {
            // console.log('Redirect success'); // Debugging only
            $('body').addClass('ajax-cart-open');
        }
    })();

    $(document).on('cart.requestComplete', function (e) {
        $cart.ajaxCartOpen();
        $cart.updateFreeShipping()
        $('body').removeClass('plp-quickview-open');
        $('.plp-quickview').removeClass('showing');
        console.log("Request complete");
    });

    var oldXHR = window.XMLHttpRequest;
    function newXHR() {
        var realXHR = new oldXHR();
        realXHR.addEventListener(
            "load",
            function () {
                if (realXHR.readyState == 4 && realXHR.status == 422) {
                    if (realXHR._url === "/cart/add.js") {
                        //we can use this to take action when an item goes out of stock in realtime
                        console.log(JSON.parse(realXHR.response))
                    }
                }
            },
            false
        );
        return realXHR;
    }
    window.XMLHttpRequest = newXHR;
});
// import $ from 'jquery';
// import lity from 'lity';

window.jQuery = $;
window.$ = $;


function emailSubscribe() {
  lity('#newsletter-modal');
  createCookie('floradixEmailSubscribe', 'true', 365);
}

if (readCookie('floradixEmailSubscribe') !== 'true') {
  emailSubscribe();
}

const postData  = (e1, e2, e3, msg) => {
  console.log('Posting...')
  const emailval = e1.val()
  const formObj = {
      contacts:
      [{
          "key_id" : "3",
          "3" : emailval,
          "31": 1,
      }],
      account: 'floradixusa.com',
      endpoint: e3
  };
  $.ajax({
      type: "POST",
      url: "https://5mdfcecucd.execute-api.us-east-1.amazonaws.com/production/emarsysapi",
      data: JSON.stringify(formObj),
      contentType:"application/json; charset=utf-8",
      dataType: "json",
      success: function(resultData) {
          console.log(resultData['emarsysResponse'])

          try{
            var obj = JSON.parse(resultData['emarsysResponse']);
            if (typeof obj.data.errors[emailval][2009] !== 'undefined' && obj.data.errors[emailval][2009] !== null){
              if(obj.data.errors[emailval][2009] == 'Contact with the external id already exists: 3'){
                console.log('Resend...')
                postData(e1, e2, 'put_contact', msg)
              }
              return;
            }
          } catch(ee){

          }

          e2.html(msg);
      }
  }).fail(function(error) {
      alert(JSON.stringify(error));
  });
}

$('#email_signup .nothanks').on('click tap', function(){
  $('button.lity-close').click();
});

$('#email_signup').submit(function(ee) {
  ee.preventDefault();

  //var msg = '<div class="ql-editor" data-gramm="false" contenteditable="false"><p style="text-align: center;"><strong class="ql-font-open-sans" style="color: rgb(56, 48, 34); font-size: 28px;">Thanks for subscribing!</strong></p><p style="text-align: center;"><br></p><p style="text-align: center;"><span style="color: rgb(112, 112, 112);">Check your email for a confirmation message.</span></p></div>';
  var msg = '<div class="ql-editor" data-gramm="false" contenteditable="false"><p class="msg-header"><strong class="ql-font-open-sans" style="color: rgb(56, 48, 34); font-size: 28px;">Thanks for subscribing!</strong></p><p class="msg">Save 15% on your first online order with coupon code WELCOME15 during checkout. If you are a new subscriber, we’ll send you an email with this code. <br/><br/>Code: WELCOME15</p></div>';



  var myEmail = $(this).find('input.email');

  if(myEmail.val()=='' || myEmail.val()==null){
    myEmail.addClass('error').attr('placeholder', 'This E-Mail field is required');
    myEmail.change( function() {
      myEmail.removeClass('error').attr('placeholder', 'E-Mail');
    });
  }else{
    postData( myEmail, $("#newsletter-modal"),'post_contact', msg );
  }
});




/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 * Alternatives
 * - Accounting.js - http://openexchangerates.github.io/accounting.js/
 *
 */



theme.Currency = (function() {
  var moneyFormat = '${{amount}}'; // eslint-disable-line camelcase

  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || moneyFormat;

    function formatWithDelimiters(number, precision, thousands, decimal) {
      thousands = thousands || ',';
      decimal = decimal || '.';

      if (isNaN(number) || number === null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        '$1' + thousands
      );
      var centsAmount = parts[1] ? decimal + parts[1] : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'");
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

$(document).ready(function() {
  var sections = new slate.Sections();
  sections.register('product', theme.Product);

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function(evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  // Target tables to make them scrollable
  var tableSelectors = '.rte table';

  slate.rte.wrapTable({
    $tables: $(tableSelectors),
    tableWrapperClass: 'rte__table-wrapper',
  });

  // Target iframes to make them responsive
  var iframeSelectors =
    '.rte iframe[src*="youtube.com/embed"],' +
    '.rte iframe[src*="player.vimeo"]';

  slate.rte.wrapIframe({
    $iframes: $(iframeSelectors),
    iframeWrapperClass: 'rte__video-wrapper'
  });

  // Apply a specific class to the html element for browser support of cookies.
  if (slate.cart.cookiesEnabled()) {
    document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
  }

  const postData  = (e1, e2, e3, msg) => {
    console.log('Posting...')
    const emailval = e1.val()
    const formObj = {
        contacts:
        [{
            "key_id" : "3",
            "3" : emailval,
            "31": 1,
        }],
        account: 'floradixusa.com',
        endpoint: e3
    };
    $.ajax({
        type: "POST",
        url: "https://5mdfcecucd.execute-api.us-east-1.amazonaws.com/production/emarsysapi",
        data: JSON.stringify(formObj),
        contentType:"application/json; charset=utf-8",
        dataType: "json",
        success: function(resultData) {
            console.log(resultData);

            try{
              var obj = JSON.parse(resultData['emarsysResponse']);
              if (typeof obj.data.errors[emailval][2009] !== 'undefined' && obj.data.errors[emailval][2009] !== null){
                if(obj.data.errors[emailval][2009] == 'Contact with the external id already exists: 3'){
                  console.log('Resend...')
                  postData(e1, e2, 'put_contact', msg)
                }
                return;
              }
            } catch(ee){

            }

            e2.html(msg);

        }
    }).fail(function(error) {
        alert(JSON.stringify(error));
    });
  }

  $('#global-footer #contact_form').submit(function(ee) {
    ee.preventDefault();

    var msg = 'Thank you for subscribing. Save 15% on your first online order with coupon code WELCOME15 during checkout. If you are a new subscriber, we’ll send you an email with this code.<br/>Code: WELCOME15 <br/><br/>';

    postData( $(this).find('input.contact_email'), $(this).prev('.message'),  'post_contact', msg );
  });

  var urlPathname = window.location.pathname;
  var urlHash = window.location.hash;

  if (urlPathname == '/challenge' && urlHash == '#contact_form') {
    $('html,body').scrollTop(0)
  }



  /*
   *  Product Sorting on collection page
  */
    Shopify.queryParams = {};
  if (location.search.length) {
    for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
      aKeyValue = aCouples[i].split('=');
      if (aKeyValue.length > 1) {
        Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
      }
    }
  }

  jQuery('#sort-by')
    .val('{{ collection.sort_by | default: collection.default_sort_by | escape }}')
    .bind('change', function() {
      Shopify.queryParams.sort_by = jQuery(this).val();
      location.search = jQuery.param(Shopify.queryParams).replace(/\+/g, '%20');
    });

    var sValue = Shopify.queryParams.sort_by;

    if (sValue === undefined ){
      jQuery('#sort-by').val('manual');
    }
   else {
    jQuery('#sort-by').val(sValue);
   }



  $('[data-scroll-to-top]').on('click', function() {
    $('html,body').animate({scrollTop:0}, 500);
  });

  $(".js-footer-nav-mobile-toggle").on("click", toggleNavDropdown);

  function toggleNavDropdown(event) {
    if (window.innerWidth <= 768 || document.documentElement.clientWidth < 768) {
     event.preventDefault();
     $(this).toggleClass("is-open-toggle");
    }
  }


   /*
      GLOBAL NAVIGATION
   */
   var breakpointMedium = 768;

   function desktopMenuEnable() {
     $('body').addClass('js-global-header-menu-active');
   }

   function desktopMenuDisable() {
     $('body').removeClass('js-global-header-menu-active');
   }

  $('#mobile-menu-toggle').on('click', function(e) {
    var screenHeight = $(window).height();
    var headerHeight = $('#global-header').height();
    var adjustedHeight = screenHeight - headerHeight;
    $('#global-header nav .linklist-menu-level-1').height(adjustedHeight);
    $(this).parent('nav').toggleClass('js-mobile-nav-active');
    $('.linklist-menu-level-1').toggleClass('is-active');
    $('.linklist-menu-level-2').toggleClass('is-active');
    $('body').toggleClass('js-global-header-menu-active');
  });


  /* ----------------------------------
      PRODUCT TABS
  ---------------------------------- */

  $('.js-tabs--tab-button').on('click', function(event) {
    event.preventDefault();
    var tabIndex = $(this).index();
    $(this).addClass('is-active').siblings().removeClass('is-active');
    $('.js-tabs--tab-block').eq(tabIndex).addClass('is-active').siblings().removeClass('is-active');
  });


  $('.product-media-gallery-list').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    asNavFor: '.product-media-gallery-thumbnail-list'
    ,dots: true
  });


  $('.product-media-gallery-thumbnail-list').slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    asNavFor: '.product-media-gallery-list',
    focusOnSelect: true,
    vertical: true,
    centerPadding: '0',
    infinite: false
  });


  var $productIndgredientsSlider = $('.product-ingredients--image-slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true,
    arrows: false,
    swipe: false
  });


  $('.js-product-ingredients--item-button').on('click', function(event) {
    var itemIndex = $(this).index();
    $(this).addClass('is-active').siblings().removeClass('is-active');
    $productIndgredientsSlider.slick('slickGoTo', itemIndex);
  });


  $('.js-product-ingredients--full-list--toggle').on('click', function(event) {
    $('.js-product-ingredients--full-list--toggle-content').slideToggle(400);
    $(this).parent().toggleClass('is-active');
  });


  $('.js-popup-open').on('click', function(event) {
    event.preventDefault();

    var popupHref = $(this).attr('href');
    var popupContent = '<img src="'+popupHref+'" >';
    $('body').addClass('js-popup-active');
    $('.js-popup-content').html(popupContent);
  });


  $('.js-popup-close').on('click', function(event) {
    event.preventDefault();
    $('body').removeClass('js-popup-active');
    $('.js-popup-content').html('');
  });



  $('.js-toggleBtn').on('click', function (e) {
    $(this).next('.js-toggleContent').slideToggle();
    $(this).toggleClass('is-open');
  });

  $('.js-mobile-accordion-toggle-button').on('click', function (e) {
    if ($(window).width() < 1024) {
      $(this).parent('.js-mobile-accordion').toggleClass('is-open');
    }
  });


  $('.product-page-section--related-products .collections-products-list').slick({
    mobileFirst: true,
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    focusOnSelect: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: "unslick"
      }
    ]
  });


  /*
    HOMEPAGE - PRODUCT CAROUSEL
  */
  $('.section--full-page-carousel-list').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    dots: false,
    centerMode: true,
    focusOnSelect: true,
    centerPadding: '6.527%',
    infinite: true,
    autoplaySpeed: 5000,
    autoplay: true,
    responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: true,
            dots: true
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            infinite: true,
            dots: true,
            autoplay: false
          }
        },
        {
          breakpoint: 521,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            dots: true
          }
        }
    ]
  });



  // Mobile Select
  $selectNav = $(".js-selectNav");

  // Create the dropdown base
  $("<select class='page-nav__select js-page-nav-select input-select' />").appendTo($selectNav);
  // Create the dropdown base

  // Populate dropdown with menu items
  $($selectNav).find("a").each(function () {
    var $item = $(this),
      $selected = $item.hasClass('current');
    $("<option />", {
      "value": $item.attr("href"),
      "text": $item.text(),
      "selected": $selected
    }).appendTo(".js-page-nav-select");

  });

  $selectNav.on("change", function () {
    $selectedNav = $(".js-page-nav-select option:selected");

    if ($selectedNav !== '') {
      window.location.href = $selectedNav.val();
    }
  });
});

/**********************************
 *    RECHARGE EVENT LISTENERS
 *********************************/

// Since Recharge v2 auto injects their widget we will have to watch when it laods in in order to place our SVG icon
$(document).ready(function() { 
  var $searchBtn = $(".search-submit-btn");

  // Wait for Search app to make update to search url
  setTimeout(() => {$searchBtn.removeAttr('disabled')}, 3000);

  var targetNode = document.querySelector('.product-form');
  var repeatSVG = '<span class="repeat-icon"><?xml version="1.0" encoding="utf-8"?><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 16 17" style="enable-background:new 0 0 16 17;" xml:space="preserve"><style type="text/css">.st0{filter:url(#Adobe_OpacityMaskFilter)}.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#FFF}.st2{mask:url(#mask-2_1_);fill-rule:evenodd;clip-rule:evenodd;fill:#383022}</style><g id="Page-1"> <g id="D---PDP-Buybox---Subscribe" transform="translate(-815.000000, -650.000000)"> <g id="repeat" transform="translate(815.000000, 650.000000)"> <g id="Mask"> </g> <defs> <filter id="Adobe_OpacityMaskFilter" filterUnits="userSpaceOnUse" x="0.1" y="0.6" width="15.1" height="16.1"> <feColorMatrix type="matrix" values="1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"/> </filter> </defs> <mask maskUnits="userSpaceOnUse" x="0.1" y="0.6" width="15.1" height="16.1" id="mask-2_1_"> <g class="st0"> <rect id="path-1_1_" y="0.3" class="st1" width="15.4" height="16.5"/> </g> </mask> <path id="Fill-1" class="st2" d="M13.5,2.7C10.4-0.2,5.5-0.1,2.4,3c-5,5-1.6,13.8,5.6,13.7c2,0,4.1-0.8,5.7-2.4 c0.5-0.5-0.2-1.2-0.7-0.7c-1.4,1.4-3.2,2.1-5,2.1c-6.3,0-9.2-7.6-4.9-12c2.7-2.7,7-2.8,9.7-0.3L12,4.3c-0.2,0.2,0,0.5,0.2,0.5 l2.6,0.1c0.2,0,0.3-0.1,0.3-0.3l0-2.7c0-0.3-0.3-0.4-0.5-0.2L13.5,2.7z"/> </g> </g> </g> </svg></span>'
  var deliveryText = '<span class="delivery-text">Delivery</span>';
  var is_sub = false;
  var observer = new MutationObserver(function(mutations){
    for (var i=0; i < mutations.length; i++){
      const subsaveElement = targetNode.querySelector('[data-price-subsave]') || false; 

      if(subsaveElement) {
        // Append text and icon based on mockup to the frequency option i.e. "Every 1 week"
        $("[data-option-subsave] .rc_widget__option__plans").prepend(repeatSVG,deliveryText);
        var is_sub = true;
        observer.disconnect();
        return
      }
    }
  });
  observer.observe(targetNode, {
    childList: true,
    subtree: true
  });

  // Prevent Add to cart to go through in order to check what is selected i.e. one time or sub
  $("form.sub-product-form").on('submit', function(e) {
    e.preventDefault();
    var productID = $(this).attr('data-variantid');
    var qty = $(this).attr('data-product-quantity');
    var selling_plan = $(this).attr('data-subscription-plan');
    var selectedType = $(`.rc_widget__option__selector input[type=radio]:checked`).val();

    var $cart = {
      gwpCount: 0,
      variantMetafieldArr: [],
      open: '.cartTrigger',
      close: '.side-cart-overlay, #close-side-cart, #contShoppingLink',
      list: '.cart-upsell-list',
      ajaxCartOpen: function () {
          $('body').addClass('ajax-cart-open');
      },
      ajaxCartClose: function () {
          $('body').removeClass('ajax-cart-open');
      },
      updateFreeShipping() {
          if (CartJS.cart.total_price > 4899) {
              $('.free-shipping').addClass('success');
          } else {
              $('.free-shipping').removeClass('success');
          }
      },
    }

    if (selectedType === 'subsave') {
      data = {
        "id": productID,
        "quantity": qty,
        "selling_plan": selling_plan
      }
    } else {
      data = {
        "id": productID,
        "quantity": qty,
      }
    }

    jQuery.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      dataType: 'json',
      success: function(res) { 
        CartJS.getCart()
      },
      fail: function(res) {
        console.log("error", res);
      }
    });
  });

  // On Qty change grab subscription plan ID
  $(document).on('change', '[data-product-qty]', function(event) {
    var qtyVal = $(this).val();
    $("form.sub-product-form").attr('data-product-quantity', qtyVal);
  });

  // On Frequency change grab subscription plan ID
  $(document).on('change', 'select[data-plans-dropdown]', function(event) {
    var sellingPlanID = $(this).find(':selected').attr('value');
    $("form.sub-product-form").attr('data-subscription-plan', sellingPlanID);
  });

  // On Variant selector change, grab variant ID for AJAX
  $(document).on('change', '.single-option-selector-product', function(event) {
      var queryString = location.search;
      variantID = queryString.split('=')[1];
      $("form.sub-product-form").attr('data-variantid', variantID);
  });

});
